import gql from 'graphql-tag';

const manageOrganisationMutation = gql`
  mutation ManageOrganisation(
    $organisationId: String!
    $input: ManageOrganisationInput!
  ) {
    manageOrganisation(organisationId: $organisationId, input: $input) {
      organisationId
      brandingCoverImageKey
      brandingDescription
      imageUrl
    }
  }
`;

export default (organisationId: string) => ({
  mutation: manageOrganisationMutation,
  module: 'organisations',
  buildVariables: (input: any) => ({
    organisationId,
    input
  })
});
